/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 

var Slider = {
  
   slideIndex: 1,
   timeout: 100,
   parent: '', 
    
  init : function(selector=false){
    if( !selector ) return;
    
    this.parent = $(selector);
    this.timeout = parseInt(this.parent.attr('data-timeout'));
    var autoplay = this.parent.attr('data-autoplay') == "true" ? true : false;
    var This = this;
    
    setTimeout(function(){
        This.parent.find('img').each(function(i, obj) {
           $(this).attr("src", $(this).attr("data-src") );
        });
      
        if( autoplay ){
          setInterval(function(){
            This.plusSlides(1);
          }, 5000 )
        }
        else{
          This.plusSlides(1);
        }
    
    }, this.timeout);
  },
  plusSlides: function(n) {
      this.showSlides(this.slideIndex += n);
  },
  currentSlide: function(n) {
      this.showSlides(this.slideIndex = n);
  },
  showSlides: function(n) {
      let i;
      let slides = this.parent.find(".slide");
      let dots = this.parent.siblings(".slideshow-dot-wrap").find(".slideshow-dot");
      if (n > slides.length) {this.slideIndex = 1}    
      if (n < 1) {this.slideIndex = slides.length}
      for (i = 0; i < slides.length; i++) {
          slides[i].style.display = "none";  
      }
      for (i = 0; i < dots.length; i++) {
          dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[this.slideIndex-1].style.display = "block";  
      dots[this.slideIndex-1].className += " active";
  }
}

$(document).ready(function(){
  console.log($('.custom-slideshow').length);
  if( $('.custom-slideshow').length )
    Slider.init('.custom-slideshow');

  $(document).on("click", "shopify-payment-terms", function(){
    $("shop-pay-button").hide();
    setTimeout(function(){
      //console.log($("#shopify-payment-terms-modal").html());
      console.log($(".navigation-buttons").html());
      $(".navigation-buttons").prepend('<div class="sample-button">Available at checkout</div>');
      $("shop-pay-button").hide();
    }, 1000)
    
  })
  
})